/* eslint-disable react/no-children-prop */
import React, { useEffect } from 'react';
import { message } from '$/components/Message';
import RoboneoContext from '$/pages/RoboneoContext';
import { InitLoginConfig, useOfficialStore } from '$/store/useOfficialStore';
import { isMobile } from '$/utils';
import { useCommonStore } from '@/store/useCommonStore';
import * as Sentry from '@sentry/react';

import { getEnv, navigate, pageAgent } from '@/common/agents';
import useIsClient from '@/hooks/useIsClient';

export default function FeatureInit() {
  const isClient = useIsClient();
  const toLogin = useCommonStore((state) => state.toLogin);
  const initUserInfo = useCommonStore((state) => state.initUserInfo);
  const init = useCommonStore((state) => state.init);
  const initialized = useCommonStore((state) => state.initialized);
  const disposeOfflineListener = useCommonStore(
    (state) => state.disposeOfflineListener,
  );
  const isUserLoggedIn = useOfficialStore((state) => state.isUserLoggedIn());
  const { locationName } = pageAgent.getCurrentPage() || {};

  const loadVconsole = async () => {
    if (isMobile() && process.env.NEXT_PUBLIC_ENVIRONMENT !== 'release') {
      const VConsole = await import('vconsole');
      // eslint-disable-next-line no-new, new-cap
      new VConsole.default();
    }
  };

  useEffect(() => {
    InitLoginConfig({
      toLogin: async () => {
        await toLogin();
        initUserInfo();
      },
    });
    init();
    loadVconsole();
  }, []);
  // 注册chat的参数

  useEffect(() => {
    if (
      initialized
      && !isUserLoggedIn
      && locationName
      && (locationName === 'studio' || locationName === 'ai_flow')
    ) {
      message.info('RoboNeo_Web_login_check_text');
      navigate({
        mode: 'url',
        url: getEnv().ENV === 'development' ? '/--roboneo/home' : '/home',
        replace: true,
      });
    }
  }, [locationName, initialized, isUserLoggedIn]);
  useEffect(() => {
    process.env.NEXT_PUBLIC_SENTRY_AUTH_TOKEN
      && Sentry.init({
        dsn: 'https://b6e0e56681874ef08814fe61c2855c74@sentry.meitu-int.com/227',
        environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
        // 按环境显式设置 release，便于将错误映射到对应部署版本的 sourcemap
        release: `roboneo-web@${process.env.NEXT_PUBLIC_ENVIRONMENT}-${Sentry.SDK_VERSION}`,
        integrations: [],
        normalizeDepth: 10, // 增加对象解析深度
        maxValueLength: 5000, // 字段最大长度
        maxBreadcrumbs: 100, // 面包屑数量限制
        tracesSampleRate: 1.0,
      });
    // 组件卸载时调用 disposeOfflineListener
    return () => {
      disposeOfflineListener();
    };
  }, []);
  if (!isClient) {
    return null;
  }
  return (
    <RoboneoContext enableVip children={null} />
  );
}
